import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { AppRoutingModule } from "./app-routing.module";
import {FileUploadModule} from 'primeng/fileupload';
import { AccordionModule } from "primeng/accordion";
import { AutoCompleteModule } from "primeng/autocomplete";
import { BadgeModule } from "primeng/badge";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { CheckboxModule } from "primeng/checkbox";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ConfirmPopupModule } from "primeng/confirmpopup";
import { ColorPickerModule } from "primeng/colorpicker";
import { ContextMenuModule } from "primeng/contextmenu";
import { DataViewModule } from "primeng/dataview";
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from "primeng/dropdown";
import { FieldsetModule } from "primeng/fieldset";
import { InplaceModule } from "primeng/inplace";
import { InputNumberModule } from "primeng/inputnumber";
import { InputMaskModule } from "primeng/inputmask";
import { InputSwitchModule } from "primeng/inputswitch";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { ListboxModule } from "primeng/listbox";
import { MegaMenuModule } from "primeng/megamenu";
import { MenuModule } from "primeng/menu";
import { MenubarModule } from "primeng/menubar";
import { MessagesModule } from "primeng/messages";
import { MessageModule } from "primeng/message";
import { MultiSelectModule } from "primeng/multiselect";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { PaginatorModule } from "primeng/paginator";
import { PanelModule } from "primeng/panel";
import { PanelMenuModule } from "primeng/panelmenu";
import { PasswordModule } from "primeng/password";
import { PickListModule } from "primeng/picklist";
import { ProgressBarModule } from "primeng/progressbar";
import { RadioButtonModule } from "primeng/radiobutton";
import { RatingModule } from "primeng/rating";
import { RippleModule } from "primeng/ripple";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { ScrollTopModule } from "primeng/scrolltop";
import { SelectButtonModule } from "primeng/selectbutton";
import { SidebarModule } from "primeng/sidebar";
import { SkeletonModule } from "primeng/skeleton";
import { SlideMenuModule } from "primeng/slidemenu";
import { SliderModule } from "primeng/slider";
import { SplitButtonModule } from "primeng/splitbutton";
import { SplitterModule } from "primeng/splitter";
import { StepsModule } from "primeng/steps";
import { TabMenuModule } from "primeng/tabmenu";
import { TableModule } from "primeng/table";
import { TabViewModule } from "primeng/tabview";
import { TagModule } from "primeng/tag";
import { ToastModule } from "primeng/toast";
import { ToggleButtonModule } from "primeng/togglebutton";
import { ToolbarModule } from "primeng/toolbar";
import { TooltipModule } from "primeng/tooltip";
import { TreeModule } from "primeng/tree";
import { TreeTableModule } from "primeng/treetable";
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';

// Application Components
import { AppCodeModule } from "./app.code.component";
import { AppComponent } from "./app.component";
import { AppMainComponent } from "./app.main.component";
import { AppConfigComponent } from "./app.config.component";
import { AppMenuComponent } from "./app.menu.component";
import { AppMenuitemComponent } from "./app.menuitem.component";
import { AppTopBarComponent } from "./app.topbar.component";
import { AppFooterComponent } from "./app.footer.component";

// Pages
import { MatrixSearchComponent } from "./argic/view/matrixsearch.component";

// Services
import { CountryService } from "./demo/service/countryservice";
import { EventService } from "./demo/service/eventservice";
import { IconService } from "./demo/service/iconservice";
import { NodeService } from "./demo/service/nodeservice";
import { PhotoService } from "./demo/service/photoservice";


// Application services
import { MenuService } from "./app.menu.service";
import { EncodeHttpParamsInterceptor, JwtInterceptor } from "./login/jwt.interceptor";
import { NologinInterceptor } from "./login/nologin.interceptor";
import { DatadownloadComponent } from "./argic/view/datadownload/datadownload.component";
import { InfodownloadComponent } from "./argic/view/infodownload/infodownload.component";
import { GeneralinfoComponent } from "./argic/view/generalinfo/generalinfo.component";

import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { SettingsComponent } from './argic/view/settings/settings.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AboutusComponent } from './website/aboutus/aboutus.component';
import { ContactComponent } from './website/contact/contact.component';
import { HomeComponent } from './website/home/home.component';
import { MyargicComponent } from './website/myargic/myargic.component';
import { WizardComponent } from './website/wizard/wizard.component';
import { RegisterComponent } from './website/register/register.component';
import { NewrequestComponent } from './website/wizard/newrequest/newrequest.component';
import { ReplaceParaPipe } from './common/pipes/replace-para.pipe';
import { ReplaceParaNewlinePipe } from './common/pipes/replace-para-newline.pipe';
import { CalendarModule } from "primeng/calendar";
import { HistoricsComponent } from "./argic/view/historics/historics.component";
import { ChangeRequestDiscussionComponent } from "./argic/view/change-request-discussion/change-request-discussion.component";
import { TechnicalcommitteeComponent } from "./argic/view/technicalcommittee/technicalcommittee.component";
import { AdminDashboardComponent } from "./argic/view/admin-dashboard/admin-dashboard.component";
import { AdminModelsComponent } from "./argic/view/admin-models/admin-models.component";
import { AdminEurocodeComponent } from "./argic/view/admin-eurocode/admin-eurocode.component";
import { AdminModelsFormComponent } from "./argic/view/admin-models-form/admin-models-form.component";
import { AdminManufacturersFormComponent } from "./argic/view/admin-manufacturers-form/admin-manufacturers-form.component";
import { AdminManufacturersComponent } from "./argic/view/admin-manufacturers/admin-manufacturers.component";
import { MatrixSearchWrapperComponent } from "./argic/view/matrixsearch-wrapper.component";
import { MyChangeRequestsComponent } from "./argic/view/my-change-requests/my-change-requests.component";


@NgModule({
    imports: [
        BrowserModule.withServerTransition({ appId: 'serverApp' }),
        FormsModule,
        AppRoutingModule,
        HttpClientModule,
        BrowserAnimationsModule,
        AccordionModule,
        AutoCompleteModule,
        BadgeModule,
        ButtonModule,
        IconFieldModule,
        InputIconModule,
        CardModule,
        CheckboxModule,
        ConfirmDialogModule,
        ConfirmPopupModule,
        ColorPickerModule,
        ContextMenuModule,
        DataViewModule,
        DialogModule,
        DropdownModule,
        FieldsetModule,
        InplaceModule,
        InputNumberModule,
        InputMaskModule,
        InputSwitchModule,
        InputTextModule,
        InputTextareaModule,
        ListboxModule,
        MegaMenuModule,
        MenuModule,
        MenubarModule,
        MessageModule,
        MessagesModule,
        MultiSelectModule,
        OverlayPanelModule,
        PaginatorModule,
        PanelModule,
        PanelMenuModule,
        PasswordModule,
        PickListModule,
        ProgressBarModule,
        RadioButtonModule,
        RatingModule,
        RippleModule,
        ScrollPanelModule,
        ScrollTopModule,
        SelectButtonModule,
        SidebarModule,
        SkeletonModule,
        SlideMenuModule,
        SliderModule,
        SplitButtonModule,
        SplitterModule,
        StepsModule,
        TableModule,
        TabMenuModule,
        TabViewModule,
        TagModule,
        ToastModule,
        ToggleButtonModule,
        ToolbarModule,
        TooltipModule,
        TreeModule,
        TreeTableModule,
        AppCodeModule,
        FileUploadModule,
        CalendarModule,
        FileUploadModule,
        ReactiveFormsModule,
        

        TranslateModule.forRoot({
            defaultLanguage: "fr",
            loader: {
                provide: TranslateLoader,
                useFactory: httpTranslateLoader,
                deps: [HttpClient],
            },
        }),
        NgbModule,
    ],
    declarations: [
        AppComponent,
        AppMainComponent,
        AppConfigComponent,
        AppMenuComponent,
        AppMenuitemComponent,
        AppTopBarComponent,
        AppFooterComponent,
        MatrixSearchWrapperComponent,
        MatrixSearchComponent,
        DatadownloadComponent,
        InfodownloadComponent,
        GeneralinfoComponent,
        SettingsComponent,
        AboutusComponent,
        ContactComponent,
        HomeComponent,
        MyargicComponent,
        WizardComponent,
        RegisterComponent,
        NewrequestComponent,
        TechnicalcommitteeComponent,
        ReplaceParaPipe,
        ReplaceParaNewlinePipe,
        HistoricsComponent,
        ChangeRequestDiscussionComponent,
        AdminDashboardComponent,
        AdminEurocodeComponent,
        AdminModelsComponent,
        AdminModelsFormComponent,
        AdminManufacturersComponent,
        AdminManufacturersFormComponent,
        MyChangeRequestsComponent
    ],
    providers: [
        /*{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }, //adds the bearer token to all calls*/
         {
           provide: HTTP_INTERCEPTORS,
           useClass: NologinInterceptor,
           multi: true,
         },

            {
              provide: HTTP_INTERCEPTORS,
              useClass: EncodeHttpParamsInterceptor,
              multi: true,
            },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        CountryService,
        EventService,
        IconService,
        NodeService,
        PhotoService,
        MenuService,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}

export function httpTranslateLoader(http: HttpClient) {
    //return new TranslateHttpLoader(http);
    return new TranslateHttpLoader(http, '/assets/i18n/', '.json?cachebust=' + new Date().getTime());
}

